import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GlobeFilledIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 5C13.7509 6.91685 14.7459 9.40442 14.8 12C14.7459 14.5956 13.7509 17.0832 12 19M12 5C10.2491 6.91685 9.25407 9.40442 9.2 12C9.25407 14.5956 10.2491 17.0832 12 19M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19M5.35001 9.9H18.65M5.35 14.1H18.65"
        stroke={fillColor || 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { GlobeFilledIcon };
